import { Container } from '@echodex/uikit'
import { CHAIN_IDS } from 'utils/wagmi'
import AllPools from 'views/AllPools/AllPools'
import ExchangeSummary from 'views/AllPools/ExchangeSummary'

const AllPool = () => {
    return (
        <Container>
            <div className="mt-[16px]">
                <ExchangeSummary />
                <AllPools />
            </div>
        </Container>
    )
}

AllPool.chains = CHAIN_IDS
export default AllPool
